import React from 'react';
import { Steven } from 'helpers/steven';
import CompanyDashboardGraphic from 'images/CompanyDashboardGraphic.png';

import ValuePropsModal, {
  Orientation,
} from 'components/paywall/ValuePropsModal.tsx';
import { translate } from 'javascripts/translations/i18n.ts';

type CompanyDashboardModalProps = {
  onRequestClose: () => void;
  isAdmin?: boolean;
};

const CompanyDashboardModal: React.FC<CompanyDashboardModalProps> = ({
  onRequestClose,
  isAdmin,
}) => {
  const primaryAction = () => {
    const actionId = isAdmin
      ? 'company_dashboard_modal_upgrade_button'
      : 'company_dashboard_modal_ok_button';
    const content = isAdmin
      ? 'Company Dashboard Modal Upgrade Button Clicked'
      : 'Company Dashboard Modal OK Button Clicked';
    const actionName = isAdmin
      ? 'company_dashboard_modal_upgrade_button_clicked'
      : 'company_dashboard_modal_ok_button_clicked';

    Steven.elementClicked({
      id: actionId,
      content,
      type: 'button',
      action: actionName,
    });
  };

  return (
    <ValuePropsModal
      title={translate('companyDashboard.modalTitle')}
      image={CompanyDashboardGraphic}
      description={translate('companyDashboard.modal.introMessage')}
      checklistItems={[
        translate('companyDashboard.modal.feature1'),
        translate('companyDashboard.modal.feature2'),
        translate('companyDashboard.modal.feature3'),
      ]}
      onRequestClose={onRequestClose}
      orientation={Orientation.VERTICAL}
      onPrimaryClick={primaryAction}
    />
  );
};

export default CompanyDashboardModal;
